import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { CORTES } from './types';

export const buscarCortes = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/cortes/listar`, body, config);
        await dispatch({ type: CORTES.BUSCAR, payload: res.data.cortes });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const informacionCorte = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/cortes/informacion`, body, config);
        await dispatch({ type: CORTES.INFORMACION, payload: res.data });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarCorte = () => dispatch => {
    dispatch({ type: CORTES.LIMPIAR });
};
